module.exports = __webpack_public_path__ + "static/img/user_pick_giveaway.9afd096.jpg";